var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoTemplates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 13,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.29 1.374 4.885 5.121-4.885 5.122-4.886-5.122zM6.29 0a1.4 1.4 0 0 0-1.024.432L.381 5.553a1.355 1.355 0 0 0 0 1.874l4.885 5.122c.261.274.643.431 1.024.431a1.4 1.4 0 0 0 1.023-.431l4.885-5.122a1.355 1.355 0 0 0 0-1.874L7.323.432A1.44 1.44 0 0 0 6.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.67 13a.7.7 0 0 1-.481-.186.674.674 0 0 1-.03-.972l5.146-5.357L9.22 1.197a.683.683 0 0 1 .03-.971.71.71 0 0 1 .993.03l5.538 5.768c.25.265.25.677 0 .942l-5.598 5.828a.7.7 0 0 1-.512.216z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.69 13a.7.7 0 0 1-.481-.186.683.683 0 0 1-.03-.972l5.156-5.357-5.107-5.288a.683.683 0 0 1 .03-.971.71.71 0 0 1 .994.03l5.557 5.768a.683.683 0 0 1 0 .942l-5.607 5.828a.7.7 0 0 1-.512.216z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19v13H0z"
})))));
export default SvgVideoTemplates;